export default __webpack_public_path__ + "static/media/exit-icon.22b1a037.png";